import { defineStore } from 'pinia';
import { computed, ref } from 'vue'
import { requestBuilder } from '@/utils/request-builder.utilities.js'
import { processResponse } from '@/utils/process-response-utilities.js'
import { instance } from '@/plugins/axios.js'
import { permissionRequestConfig } from '@/config/permissions.constant.js'

const {getAllRecords} = requestBuilder()
export const usePermissionStore = defineStore('permission', () => {
  const permissions = ref([]);
  const isLoading = ref(false);
  const isLoaded = ref(false);
  const userURL = computed(() => {
    return import.meta.env.VITE_USERS_API_URL + 'request'
  })

   const getPermissions = async () => {
    isLoading.value = true;
     const {data:res} = await instance.post(userURL.value, {
       request: permissionRequestConfig.request,
       type: permissionRequestConfig.type.authUserList
     })
    isLoading.value = false;
    const isResponseOk = processResponse(res);
    if (!isResponseOk) permissions.value = [];
    permissions.value = res.data
     isLoaded.value = true;
    console.log('Permissions loaded into state');
   };

  const setPermissions = (newPermissions) => {
    permissions.value = newPermissions;
  };

  const clearPermissions = () => {
    permissions.value = [];
    isLoaded.value = false;
  }
   const hasPermission = (permission) => {
    return permissions.value.includes(permission);
  };

  const hasAnyPermission = (requiredPermissions) => {
    if (!Array.isArray(requiredPermissions)) return false;
    return requiredPermissions.some((perm) => permissions.value.includes(perm));
  };

  const hasAllPermissions = (requiredPermissions) => {
    if (!Array.isArray(requiredPermissions)) return false;
    return requiredPermissions.every((perm) => permissions.value.includes(perm));
  };

  return {
    permissions,
    isLoading,
    isLoaded,

    getPermissions,
    setPermissions,
    clearPermissions,

    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  };
});
